import { createRef } from 'react'

import { useNavigate } from 'react-router-dom'
import { Routes } from 'common/constants'
import { TSignalType } from 'common/types'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useAppContext } from 'contexts/app-context/hooks/useAppContext'
import { useHasScroll } from 'common/hooks/useHasScroll'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'

export function useFeedbackPage(type: TSignalType) {
  const ref = createRef<HTMLDivElement>()
  const hasScroll = useHasScroll(ref)
  const navigate = useNavigate()

  const { privacyCenterContent, userSelectedEntity } = useAppContext()

  const supportFailed = privacyCenterContent?.components.supportFailed
  const supportSuccess = privacyCenterContent?.components.supportSuccess

  const isError = type === 'error'

  const screen = isError ? Routes.ERROR_SENDING_REPORT : Routes.SUCCES_SENDING_REPORT
  const action = isError ? 'supportRequestFailed' : 'supportRequestSuccess'

  useScreenFinishLoadTac({
    name: 'FeedbackPage',
    entity: userSelectedEntity,
    action,
    screen,
    shouldSend: true,
    logLabel: 'send feedback page tac',
  })

  const navigateToMyServices = async () => {
    try {
      await sendSelectContent({
        flow: 'feedback_page',
        step: screen,
        screen_name: screen,
        element_name: 'returnToMyServices',
        element_type: 'button',
        parent_name: 'FeedbackPage',
        scenario: JSON.stringify({
          screen,
          product: userSelectedEntity,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send feedback page return tic', error)
    }

    navigate(Routes.MY_SERVICE_REQUESTS)
  }

  if (!supportFailed || !supportSuccess) {
    return {
      feedbackContent: {
        icon: '',
        title: '',
        details: '',
        confirmButton: '',
        cancelButton: '',
        email: '',
        hasScroll,
        ref,
      },
      onClick: navigateToMyServices,
    }
  }

  return {
    feedbackContent: {
      ...(isError ? supportFailed : supportSuccess),
      hasScroll,
      ref,
    },
    onClick: navigateToMyServices,
  }
}
